/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { BookingService } from '../Service';
import { Box, Card, Divider, IconButton, Modal, Step, StepContent, StepLabel, Stepper, Typography } from '@mui/material';
import { formatDateTime } from '../../../utils/dateUtils';
import { BookingDetailsContext } from './Viewdetails';
import dayjs from 'dayjs';
import { ZoomInMap, ZoomOut, ZoomOutMap } from '@mui/icons-material';

const BookingLogs = () => {
    const {bookingId} = useParams();
    const {bookingDetailsdata} = useContext(BookingDetailsContext)
    const [activeStep, setActiveStep] = useState(0);
    const [bookingLog,setBookingLog] = useState([]);
    const [maximizeLogModal,setMaximizeLogModal] = useState(false);

    const fetchLog = async () => {
        const logResponse = await BookingService.getBookingLogs(bookingId);
        console.log('Log Response:',logResponse);
        if(logResponse.status == 'success'){
            setBookingLog(logResponse.data);
            setActiveStep(logResponse.data.length);
        }
    }
    useEffect(() => {
        if(bookingId>0){
            console.log('Booking Id:',bookingId);
            fetchLog();
        }
    },[bookingId,bookingDetailsdata])
    const CustomStepIcon = ({ active, completed }) => {
        return (
            <Box
                sx={{
                    width: 5, // Adjust size
                    height: 5, // Adjust size
                    borderRadius: "50%",
                    backgroundColor: completed || active ? "primary.main" : "grey.400",
                }}
            />
        );
    };

  return (
    <>
        <Card sx={{mb:'2%'}} >
            <Box sx={{ my:'1%',px:'2%',borderBottom:'1px solid #E0E0E0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,py:'1%',justifyContent:'space-between' }}>
                    <Typography sx={{ fontWeight: '600',fontSize:'0.85rem' }}>{`Booking Summary`}</Typography>
                    <IconButton size='small' onClick={() => setMaximizeLogModal(true)} >
                        <ZoomOutMap sx={{fontSize:'0.75rem'}}/>
                    </IconButton>
                </Box>
            </Box>
            <Box sx={{px:'2%',maxHeight:'12rem',minHeight:'7rem',overflowY:'auto'}}>
                <Stepper activeStep={activeStep} orientation="vertical" 
                    sx={{
                        '& .MuiStepConnector-root': {
                            marginLeft: '.55%',
                        },
                        '& .MuiStepConnector-line': {
                            minHeight:'.5rem'
                        },
                    }}
                >
                    {bookingLog && bookingLog.map((step, index) => (
                        <Step key={index} expanded={true}>
                            <StepLabel StepIconComponent={CustomStepIcon} sx={{p:0}}>
                                <Typography sx={{fontSize:'0.65rem',fontWeight:500}}>Booking 
                                    <Box component={'span'} sx={{textTransform:'capitalize',ml:'1%'}}>{step.newStatus}</Box>
                                    <Box component={'span'} sx={{textTransform:'capitalize',ml:'2%',color:'lightGray'}}> on {formatDateTime(step?.updatedAt)}</Box> 
                                </Typography>
                            </StepLabel>
                            <StepContent sx={{ml:'.55%',lineHeight:.5}}>
                                <Box>
                                    {
                                        step.newStatus == 'rescheduled' &&(
                                        <>
                                            <Typography variant='caption' sx={{fontSize:'.5rem'}}>Rescheduled from:
                                                <Box component={'span'} sx={{textTransform:'capitalize',ml:'1%'}}>{formatDateTime(step?.details?.prevServiceDate,'date')}</Box> ,
                                                <Box component={'span'} sx={{textTransform:'capitalize',ml:'1%'}}>
                                                    {dayjs(step?.details?.prevStartTime, 'HH:mm:ss').format('h:mm A')} - 
                                                    {dayjs(step?.details?.prevEndTime, 'HH:mm:ss').format('h:mm A')}
                                                </Box>

                                            </Typography>
                                            {/* <Typography variant='body2'></Typography> */}

                                        </>
                                        )
                                    }
                                </Box>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </Box>        
        </Card>
        {/* Modal to show all info like who updated the status and more using modal */}
        <Modal
            open={maximizeLogModal}
            // onClose={() => setMaximizeLogModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 600,
                bgcolor: 'background.paper',
                // border: '2px solid #000',
                // boxShadow: 24,
                pt: 2,
                px: 4,
                pb: 3,
                borderRadius:'1rem'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,py:'1%',justifyContent:'space-between' }}>
                    <Typography sx={{ fontWeight: '600',fontSize:'0.85rem' }}>{`Booking Summary`}</Typography>
                    <IconButton size='small' onClick={() => setMaximizeLogModal(false)} >
                            <ZoomInMap sx={{fontSize:'0.75rem'}}/>
                    </IconButton>
                </Box>
                <Divider/>
                <Box sx={{mt:'2%'}}>
                    <Stepper activeStep={activeStep} orientation="vertical" 
                        sx={{
                            '& .MuiStepConnector-root': {
                                marginLeft: '.55%',
                            },
                            '& .MuiStepConnector-line': {
                                minHeight:'.5rem'
                            },
                        }}
                    >
                        {bookingLog && bookingLog.map((step, index) => (
                            <Step key={index} expanded={true}>
                                <StepLabel StepIconComponent={CustomStepIcon} sx={{p:0}}>
                                    <Typography sx={{fontSize:'0.75rem',fontWeight:500}}>Booking 
                                        <Box component={'span'} sx={{textTransform:'capitalize',ml:'1%'}}>{step.newStatus}</Box>
                                        <Box component={'span'} sx={{textTransform:'capitalize',ml:'2%',color:'lightGray'}}>{formatDateTime(step?.updatedAt)}</Box>
                                    </Typography>
                                </StepLabel>
                                <StepContent sx={{ml:'.55%',lineHeight:.5}}>
                                    <Box>
                                        { step.newStatus == 'rescheduled' &&
                                        <Typography variant='body2' sx={{fontSize:'.65rem'}}>Rescheduled from:
                                            <Box component={'span'} sx={{textTransform:'capitalize',ml:'1%'}}>{formatDateTime(step?.details?.prevServiceDate,'date')}</Box> ,
                                            <Box component={'span'} sx={{textTransform:'capitalize',ml:'1%'}}>
                                                {dayjs(step?.details?.prevStartTime, 'HH:mm:ss').format('h:mm A')} - 
                                                {dayjs(step?.details?.prevEndTime, 'HH:mm:ss').format('h:mm A')}
                                            </Box>
                                        </Typography>   }  
                                        <Typography variant='body2' sx={{fontSize:'.65rem'}}>Updated By:
                                            <Box component={'span'} sx={{textTransform:'capitalize',ml:'1%'}}>
                                                {
                                                    step.creatorRoleId =='1' ? <>CET Team <Box component={'span'} sx={{color:'#1976d2'}}>{`(${step.createdById})`}</Box></> 
                                                    : step.creatorRoleId == '2' ? 'Customer' : 'Service Expert'
                                                }
                                            </Box> 
                                        </Typography>                                                                              
                                    </Box>
                                </StepContent>
                            </Step>
                        ))} 
                    </Stepper>
                </Box>
            </Box>
        </Modal>
    </>
  )
}

export default BookingLogs